import repositories from '@/repositories/RepositoryFactory'
export default {
  /**
   * 商品分類条件の標準フォーマット
   */
  get() {
    return {
      /**
       * @see store.js
       */
      key: new Date().getTime().toString(),
      /**
       * 企業コード
       */
      company: undefined,
      /**
       * 選択モード（商品:item / 分類:category）
       */
      selectMode: 'category',
      /**
       * 選択分類（最下層）一覧
       */
      categories: undefined,
      /**
       * 選択商品一覧
       */
      items: undefined,
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(item) {
    if (item.selectMode === 'item') {
      return {
        selectMode: item.selectMode,
        items: item.items.map(i => i.code),
      }
    } else if (item.selectMode === 'category') {
      return {
        selectMode: item.selectMode,
        categories: item.categories,
      }
    }

    throw new Error(`unknown item select mode: ${item.selectMode}`)
  },
  /**
   * applyToに対してitemを適用する
   */
  applyPayload(applyTo, item, company) {
    applyTo.key = new Date().getTime().toString()
    applyTo.company = item.company

    // 商品（分類から、商品から）選択と分類（階層）選択があるパターン
    switch (item.selectMode) {
      case 'category':
      case 'itemCategory':
        applyTo.selectMode = 'category'
        applyTo.categories = item.categories
        break
      case 'item':
        applyTo.selectMode = 'item'

        repositories
          .get('item')
          .getByCode(company, item.items, {
            categoryLevel: undefined,
            categories: undefined,
          })
          .then(items => {
            applyTo.items = items
          })

        break
    }
    return
  },
  summaryText(item) {
    if (item.selectMode === 'category') {
      return item.categories.length + '分類'
    } else if (item.selectMode === 'item') {
      return item.items.length + '商品'
    }
    return ''
  },
}
